import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { isMultipleExceptions } from './utils';
import { ODFulfilmentGroups } from './ODInterfaces';

export const ODTableExceptionBadge = ({
  exceptions,
}: {
  exceptions: ODFulfilmentGroups[];
}) => {
  const exceptionStatus = isMultipleExceptions(exceptions);

  if (exceptionStatus === undefined) {
    return null;
  }

  return (
    <Badge variant="subtle" color="warning" size="small">
      {exceptionStatus}
    </Badge>
  );
};
